import { useEffect, useMemo, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Button, CircularProgress, FormControl, Grid, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import { useLocation } from 'react-router-dom';
import { apiUrl } from '../../../config';
import DownloadIcon from '@mui/icons-material/Download';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export default function BatchReportView() {
    const query = useQuery();
    const id = query.get('id');

    const [data, setData] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [filterData, setFilterData] = useState({
        dateFrom: '',
        dateTo: '',
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData()
    }, [filterData]);

    const getData = async () => {
        try {
            setLoading(true);
            const response = await apiService.get('/report/batch/view', {
                params: {
                    _id: id,
                    ...filterData,
                },
            });
            setData(response?.data?.batchs);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/batch/view', {
                params: {
                    _id: id,
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <div style={{ height: '70vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                BATCHES REPORT
            </Typography>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2}}>
                <Grid item xs={6} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Fee Pending From"
                                value={filterData.dateFrom ? dayjs(filterData.dateFrom) : null}
                                onChange={(date) => handleChange('dateFrom', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={6} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Fee Pending To"
                                value={filterData.dateTo ? dayjs(filterData.dateTo) : null}
                                onChange={(date) => handleChange('dateTo', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={8}>
                    <Button variant="outlined" size='small' sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                </Grid>
            </Grid>
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>
            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    disableDensitySelector
                    columns={[
                        { field: 'name', headerName: 'Name', flex: 1 },
                        { field: 'phoneNumber', headerName: 'Phone Number', flex: 1 },
                        { field: 'present', headerName: 'Present', flex: 1 },
                        { field: 'absent', headerName: 'Absent', flex: 1 },
                        { field: 'mockExams', headerName: 'Mock Exams', flex: 1 },
                        { field: 'receivedFee', headerName: 'Fee Received', flex: 1 },
                        { field: 'pendingFee', headerName: 'Fee Pending', flex: 1 },
                    ]}
                    rowCount={totalResults}
                />
            )}
        </div>
    );
}
